module.exports = __webpack_public_path__ + "static/media/circle-ci.e2662ea2.svg";